import ErrorEntities from '@/models/error-entities'

import { CreditCardMutationTypes } from '@/store/modules/credit-cards'

export interface State {
  visible: boolean
  errors: ErrorEntities
}

export enum AddCreditCardModalMutationTypes {
  Open = '[AddCreditCardModal] Open',
  Toggle = '[AddCreditCardModal] Toggle',
}

const initialState: State = {
  visible: false,
  errors: {},
}

export default {
  state: initialState,
  getters: {
    getAddCreditCardModalVisible(state: State) {
      return state.visible
    },
    getAddCreditCardModalErrors(state: State) {
      return state.errors
    },
  },
  mutations: {
    [CreditCardMutationTypes.AddCard](state: State) {
      state.errors = {}
    },
    [CreditCardMutationTypes.AddCardSuccess](state: State) {
      state.visible = false
    },
    [CreditCardMutationTypes.AddCardFailure](
      state: State,
      errors: ErrorEntities,
    ) {
      state.errors = errors
    },
    [AddCreditCardModalMutationTypes.Open](state: State) {
      state.visible = true
    },
    [AddCreditCardModalMutationTypes.Toggle](state: State, visible: boolean) {
      state.visible = visible
    },
  },
}
